import ActionsForm from '@/shared/mixins/actionsForm'
import SurveyRepository from '@/shared/http/repositories/business/Survey'
import { loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

export default {
  props: ['filtrar', 'filtro'],
  mixins: [ActionsForm],
  name: 'tablesurvey',
  data () {
    return {
      headTable: ['Tipo Obra', 'Código', 'Cliente', 'Contrato', 'Responsável', 'Data Vistoria', 'Status', 'Ação'],
      status: [{
        Mensagem: '',
        class: ''
      }
      ],
      id: null
    }
  },
  mounted () { this.onLoad() },
  methods: {
    onLoad () {
      loading.push()
      SurveyRepository.GetAllTableSST(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex, this.filtrar)
        .then(Response => {
          this.onResultGrid(Response)
          loading.pop()
        })
        .catch(Error => this.onException(Error))
    },
    filtarPaging () {
      loading.push()
      SurveyRepository.GetAllTableSST(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex, this.filtrar)
        .then(Response => {
          this.ChangeData(Response.data.data)
          this.$refs.tableGrid.LoadAllByData(Response)
          loading.pop()
        })
        .catch(error => this.onException(error))
    },
    FormatDate (value) {
      return Tools.FormatDateBrazilian(value)
    },
    getclassstatus (value) {
      if (value === 0) {
        this.status.class = 'rgb(192, 192, 192)'
      }
      if (value === 1) {
        this.status.class = 'rgb(212, 238, 253)'
      }
      if (value === 2) {
        this.status.class = '#ffeadc'
      }
      if (value === 3) {
        this.status.class = '#cbe9cf'
      }
      return this.status.class
    },
    getclassstatuFont (value) {
      if (value === 0) {
        return 'rgb(106, 106, 106)'
      }
      if (value === 1) {
        return 'rgb(0, 55, 137)'
      }
      if (value === 2) {
        return 'rgb(255 96 0 / 92%)'
      }
      if (value === 3) {
        return 'rgb(19, 59, 26)'
      }
    },
    formatStatusVistoria (value) {
      if (value === 0) {
        this.status.Mensagem = 'NÃO ENVIADO'
      }
      if (value === 1) {
        this.status.Mensagem = 'AG. APROVAÇÃO'
      }
      if (value === 2) {
        this.status.Mensagem = 'AG. CORREÇÃO'
      }
      if (value === 3) {
        this.status.Mensagem = 'APROVADO'
      }
      return this.status.Mensagem
    },
    onDelete (obj) {
      loading.push()
      SurveyRepository.Delete(obj.id)
        .then(Response => {
          this.onLoad()
          loading.pop()
        })
        .catch(Error => this.onException(Error))
    },
    onChange (obj) {
      loading.push()
      SurveyRepository.Inativar(obj.id)
        .then(Response => this.onResultGrid(Response))
        .catch(Error => this.onException(Error))
    },
    changeStatus (value) {
      loading.push()
      SurveyRepository.changestatusTable(this.id, value)
        .then(Response => {
          loading.pop()
          this.$refs['aprovedVistoria'].hide()
          this.onLoad()
        })
        .catch(Error => this.onException(Error))
    },
    ChangeData (obj) {
      this.checkQuantityObj(obj)
      this.objList = obj
    },
    checkQuantityObj (obj) {
      this.$refs.tableGrid.total = obj.length
    },
    loadTable (Response) {
      this.$refs.tableGrid.Clear()
      this.$refs.tableGrid.LoadAllByData(Response)
    },
    openAprovedVistoria (value) {
      this.id = value
      this.$refs['aprovedVistoria'].show()
    },
    closeAprovedVistoria () {
      this.$refs['aprovedVistoria'].hide()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/Survey/components/tableSurvey/tableSurvey.js